import React, { useState, useEffect, useRef } from 'react';
import AceEditor from 'react-ace';
import { config as aceConfig } from 'ace-builds';
import _ from 'lodash';

import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-mono_industrial";

aceConfig.set(
    "basePath",
    "https://cdn.jsdelivr.net/npm/ace-builds@1.4.12/src-noconflict/"
  );
aceConfig.setModuleUrl(
    "ace/mode/json_worker",
    "https://cdn.jsdelivr.net/npm/ace-builds@1.4.12/src-noconflict/worker-json.js"
);

export interface ISchemaEditorProps {
    schema: object;
    onValue: (value: object) => void;
}

const MemoAce = React.memo(AceEditor);

export const SchemaEditor = ({ schema, onValue }: ISchemaEditorProps) => {
    const [ currentText, setCurrentText ] = useState(JSON.stringify(schema, null, 4));
    const refSchema = useRef(schema);

    useEffect(() => {
        if (!_.isEqual(schema, refSchema.current)) {
            setCurrentText(JSON.stringify(schema, null, 4));
            refSchema.current = schema;
        }
    }, [ schema ]);

    const onValueChange = (text: string) => {
        setCurrentText(text);
        try {
            const newSchema = JSON.parse(text) as object;
            if (!_.isEqual(refSchema.current, newSchema)) {
                refSchema.current = newSchema;
                onValue(newSchema);
            }
        } catch {}
    }

    return (<MemoAce
        mode="json"
        theme="mono_industrial"
        value={currentText}
        onChange={onValueChange}
        name="ace-editor"
        height="100%"
        width="100%"
    />);
}